import OrderNumberModal from '../OrderNumberModal/order-number-modal';

export default OrderNumberModal;